module.exports = __webpack_public_path__ + "img/9788956373645.efd0c875.jpg";